package org.catharsis.spendtel.core.navigation

import kotlinx.serialization.Serializable

enum class AppRoutes {
    Landing,
    Authentication,
    FinancialGoal,
    EditFinancialGoal,
    Home,
    Settings,
    HowItWorks,
    PrivacyPolicy,
    TermsAndConditions,
    ContactSupport,
}

@Serializable
data class ExpenseReportRoute(
    val reportId: String,
)

@Serializable
data class PublicShareRoute(
    val shareId: String,
)
